<template lang="pug">
  .liaoning-flow
    .header
      img(src="../../../public/images/liaoning/low2.png")
    .form
      //- .packages
      //-   .package
      //-     .title
      //-       .name
      //-         | 承诺低消
      //-         span.price 88
      //-         | 元
      //-       .priod 有效期：12个月
      //-     .desc
      //-       span.label-bold 享
      //-       | 20G国内套外流量，优+畅看彩云包(30G咪咕视频定向流量+15元咪咕视频钻石会员+2T和彩云移动网盘+优+轻享版会员)
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入辽宁移动手机号")
        el-form-item
          .verifycode
            .txt-verfiycode
              input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="6")
            .btn-verifycode
              button(type="button", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后重试
        el-form-item.button-item
          img.img-button(src="../../../public/images/xinjiang/button.png", @click="handleSubmit")
    .notice
      .title - 活动规则 -
      .content
        ul
          li(v-for="(notice, index) in notices", :key="index", v-if="index <= 1 || showMoreNotice")
            .num {{index + 1}}.
            .content(v-if="typeof(notice) === 'object'")
              p {{notice.text}}
              p.child(v-for="child in notice.children", :key="child") {{child}}
            .content(v-else) {{notice}}
        .show-more(v-if="!showMoreNotice", @click="showMoreNotice = true") 点击查看更多活动规则
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      notices: [
        '产品说明：本产品合约期12个月，合约期内不可离网。产品包含20GB国内通用流量和“优+畅看彩云包”权益，办理后立即生效，到期将自动延续1年优惠，同时每月再额外增加2G国内通用流量。',
        '资费说明：本产品0资费办理，办理后用户需保持每月低消88元。',
        {
          text: '流量说明：',
          children: [
            '（1）使用说明：本产品所含流量不适用于港澳台地区，流量流量不可结转、不可转赠、不可共享。',
            '（2）流量优先级说明：优先级低于小时包、日包、主套内流量。'
          ]
        },
        {
          text: '权益说明：',
          children: [
            '（1）权益内容：本权益包含30G咪咕视频定向流量+15元咪咕视频钻石会员+2T和彩云移动网盘+“优+轻享版会员”。',
            '（2）领取路径：30G咪咕视频定向流量+15元咪咕视频钻石会员+2T和彩云移动网盘自动下发；关注“福利社优+”微信号~菜单栏“领权益”~“好礼三选一领权益”即可领取查看优加畅看彩云包权益。'
          ]
        },
        {
          text: '流量说明：',
          children: [
            '（1）取消方式：活动期内，客户可持机主有效证件到自有营业厅办理活动终止，不支持他人代办。当月取消立即生效。',
            '（2）取消违约金：违约金=活动参与月数*10元（含当月）。'
          ]
        }
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 10,
        userId: '',
        goodsCode: 'TUIA10201026001'  //TUIA10201026002  68
      },
      channel: 'TUIA',
      showMoreNotice: false
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.form.goodsCode
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.form.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            this.syncOrderStatus(res.data.sub_data.orderId)
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    syncOrderStatus(orderId) {
      try{
        let _loading = this.$loading({
          lock: true,
          text: '请稍后，正在查询办理结果',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$service.CarrierService
          .queryOrder(orderId)
          .then(res => {
            // W-等待运营商返回处理结果；0-办理成功；1-办理失败，
            if (res.data.success) {
              if (res.data.sub_data.execStatus == '0') {
                _loading.close()
                if (window.countLog) {
                  window.countLog.ready(function() {
                    window.countLog.init(function() { 
                    }, {
                      isCopy: 0, 
                      pageType: 0 
                    })
                  })
                }
                this.$message({
                  type: 'success',
                  message: '办理成功'
                })
                this.$router.push({
                  name: 'liaoningFlowCommonSuccess'
                })
              } else if (res.data.sub_data.execStatus == 'W') {
                setTimeout(() => {
                  _loading.close()
                  this.syncOrderStatus(orderId)
                }, 1000)
              } else {
                _loading.close()
                this.$message({
                  type: 'warning',
                  message: `订单查询：办理失败`
                })
              }
            } else {
              _loading.close()
              this.$message({
                type: 'warning',
                message: res.data.message
              })
            }
          })
          .catch(() => {
            _loading.close()
            this.$message({
              type: 'error',
              message: '办理失败，请稍后再再试'
            })
          })
      } catch (err) {
        console.log(err)
        this.errlog = err.message;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.liaoning-flow{
  background-color: #061641;
  padding-bottom: 3.5rem;
}
.header{
  img{
    width: 100%;
  }
}
.notice{
  font: "黑体", "Arial";
  margin-top: 1rem;
  .title{
    text-align: center;
    color: #fff;
    margin-bottom: .5rem;
  }
  >.content{
    margin: 0 auto;
    width: 82%;
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #fff;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
    .show-more{
      text-align: center;
      font-size: .8rem;
      color: #a3a3a3;
    }
  }
}
.form{
  width: 80%;
  margin: 0 auto;
  margin-top: -13.8rem;
  padding: 1rem;
  // background-color: #FFFFFF;
  // border-radius: 12px;
  // box-shadow: 0 6px 6px #90cafa;
  .button-item{
    text-align: center;
    .el-button{
      width: 100%;
    }
  }
  .verifycode{
    display: flex;
    height: 40px;
    line-height: 40px;
  }
  .img-button{
    width: 100%;
    margin-top: -.8rem;
  }
  .btn-verifycode{
    flex: .7;
    button{
      background-color: #fff;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      width: 100%;
      border: 0;
      outline: 0;
      padding: 0;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .txt-verfiycode{
    width: 100%;
    flex: 1.3;
    input{
      background-color: #fff;
      // border: 1px solid #DCDFE6;
      border: 0;
      border-right: 0;
      padding: 0 15px;
      outline: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #606266;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right-color: #fff;
      box-sizing: border-box;
      &::-webkit-input-placeholder{
        color: #b9b9b9;
        font-size: 14px;
      }
    }
  }
}
.packages{
  margin-bottom: 1rem;
  .package{
    background-color: #DDF1FF;
    text-align: center;
    border-radius: 16px;
    padding: 6px;
    .title{
      display: flex;
      padding: 0 1rem;
      >div{
        flex: 1;
        height: 4rem;
        line-height: 4rem;
      }
      .name{
        font-size: 1.2rem;
        color: #5783EF;
        .price{
          font-size: 2.2rem;
        }
      }
      .priod{
        font-size: 1rem;
        text-align: right;
        color: #FC9898;
      }
    }
    .desc{
      background-color: #FABB00;
      color: #fff;
      padding: 6px 12px;
      border-radius: 12px;
      text-align: left;
      margin: 0 .5rem;
      .label-bold{
        font-size: 1.3rem;
        font-weight: bold;
      }
    }
  }
}
.btn-verify{
  width: 100%;
}
</style>
